// import "element-plus/theme-chalk/dark/css-vars.css"; // 暗黑风格
import "element-plus/dist/index.css";
import "./assets/style/init.scss";
import "virtual:windi.css";
import "virtual:svg-icons-register";
import { createApp } from "vue";
import SdsnUiVue3 from "sdsn-ui-vue3";

import App from "./App.vue";
import init from "./run";

import store from "@/store/index";
import router from "@/router/index";
import golbal from "@/run/golbal";
import {useUserStore} from "@/store/user";

const app = createApp(App);
app.config.errorHandler = (error: any) => {
  console.log(error);
};
app.use(store).use(router).use(golbal).use(SdsnUiVue3)

// ========== 新增：从 localStorage 恢复登录状态 ==========
const userStore = useUserStore();   // 必须在 app.use(store) 之后调用
const token = localStorage.getItem("token");
const userInfoStr = localStorage.getItem("userInfo");

if (token) {
  userStore.setToken(token);
  if (userInfoStr) {
    try {
      const userInfo = JSON.parse(userInfoStr);
      userStore.setUser(userInfo);
    } catch (e) {
      console.warn("解析 userInfo 失败", e);
    }
  }
}app.

mount("#app");
init({ router });
